import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";

const showFatal = (message) => {
  if (document.getElementById("xevon-fatal")) return;
  const el = document.createElement("div");
  el.id = "xevon-fatal";
  el.setAttribute("data-testid", "fatal-error-screen");
  el.style.cssText =
    "position:fixed;inset:0;z-index:9999;background:#000;color:#F5F5F5;display:flex;align-items:center;justify-content:center;padding:24px;font-family:ui-monospace,monospace;";
  el.innerHTML = `<div style="max-width:640px;width:100%;border:1px solid rgba(255,255,255,0.15);border-radius:16px;padding:24px;">
    <p style="font-size:18px;font-weight:700;margin-bottom:8px;">Xevon hit an error</p>
    <p style="font-size:12px;color:#A3A3A3;margin-bottom:16px;">Screenshot this and send it over — it tells us exactly what's wrong.</p>
    <pre style="white-space:pre-wrap;word-break:break-word;font-size:12px;color:#D4D4D4;"></pre>
  </div>`;
  el.querySelector("pre").textContent = `${message}\n\nUA: ${navigator.userAgent}\nURL: ${location.href}`;
  document.body.appendChild(el);
};

window.addEventListener("error", (e) => {
  if (e.message) showFatal(e.message);
});
window.addEventListener("unhandledrejection", (e) => {
  showFatal(`Unhandled promise rejection: ${e.reason?.message || e.reason}`);
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>,
);
